import { HTTP } from "../../../shared/services/Http.service";
import type { ApiPaginatedResponse } from "../../../shared/types/interfaces/Source";
import URL_API_CONSULTAS from "../../../shared/utils/ApiUrl/ApiConsultaGestionCasos";
import URL_API_GESTION_DOCUMENTOS from "../../../shared/utils/ApiUrl/ApiGestionDocumentos";
import type { TipoConsultaUsuarioEnum } from "../../escritorio/types/enums/TipoUsuario.enum";
import type { GrupoCanalArchivo } from "../types/enums";
import type { DataFileTable, FileStats } from "../types/interfaces";

const http = HTTP();


export const GetFilesCasosByUsers = async (params: { 
  tipoConsulta?: TipoConsultaUsuarioEnum; 
  id?: number; 
  idGrupoCanal?: GrupoCanalArchivo; 
  searchTerm?: string;
  pageNumber?: number; 
  pageSize?: number }): Promise<ApiPaginatedResponse<DataFileTable, any>> => {
    const {id, tipoConsulta, idGrupoCanal, searchTerm = '', pageNumber, pageSize} = params;
    let queryString = `?TipoConsulta=${tipoConsulta}&Id=${id}&PageNumber=${pageNumber}&PageSize=${pageSize}&Parametro=${searchTerm}`;
    if (idGrupoCanal != null) queryString += `&IdGrupoCanal=${idGrupoCanal}`;
    return await http.Get(`${URL_API_CONSULTAS.GET_FILES_USER}${queryString}`, {});
};

export const GetTotalsFilesByUsersOrEntity = async (params: { 
  tipoConsulta: TipoConsultaUsuarioEnum; 
  id: number; }): Promise<FileStats> => {
    const {id, tipoConsulta} = params;
    return await http.Get(`${URL_API_CONSULTAS.GET_TOTALS_FILES_BY_USERS_OR_ENTITY}?tipoConsulta=${tipoConsulta}&id=${id}`, {});
};

export const obtenerUrlConSasToken = async (urlOrigen: string) : Promise<{ok: boolean, message: string, urlProcessed: string}> => {
  return await http.Post(`${URL_API_GESTION_DOCUMENTOS.OBTENER_URL_CON_SAS_TOKEN}?urlBlob=${encodeURIComponent(urlOrigen)}`, {});
}

/**
 * Registra las actividades de un documento tanto visualizacion como descarga.
*/
export async function VizualizacionDescargaDocumento(queryString : string): Promise<any> {
  return await http.Get(`${URL_API_GESTION_DOCUMENTOS.VISUALIZACION_DESCARGA_DOCUMENTO}${queryString}`, {});
}